import api from './api';

export interface Banco {
    nroBanco: number;
    nombreBanco: string;
    tipoDeCuenta?: string;
    nroDeCuenta?: string;
    cbu?: string;
    titular?: string;
    sucursal?: string;
    nroCtaCble?: number;
    [key: string]: any; // Para campos adicionales que puedan venir del backend
}

export interface BancoSearchParams {
    searchTerm?: string;
    pageNumber: number;
    pageSize: number;
}

export interface BancoPagedResult {
    items: Banco[];
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
}

const bancoService = {
    getBancos: async (params: BancoSearchParams): Promise<BancoPagedResult> => {
        const response = await api.get<BancoPagedResult>('/api/Banco', { 
            params: {
                SearchTerm: params.searchTerm,
                PageNumber: params.pageNumber,
                PageSize: params.pageSize
            }
        });
        return response.data;
    },

    getBanco: async (nroBanco: number): Promise<Banco> => {
        const response = await api.get<Banco>(`/api/Banco/${nroBanco}`);
        return response.data;
    },

    createBanco: async (banco: Banco): Promise<Banco> => {
        const response = await api.post<Banco>('/api/Banco', banco);
        return response.data;
    },

    updateBanco: async (nroBanco: number, banco: Banco): Promise<void> => {
        await api.put(`/api/Banco/${nroBanco}`, banco);
    },

    deleteBanco: async (nroBanco: number): Promise<void> => {
        await api.delete(`/api/Banco/${nroBanco}`);
    }
};

export default bancoService;


